import { c as _c } from "react/compiler-runtime";
import { parseAsString, useQueryStates } from 'nuqs';
export function useCommentParams() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      comment: parseAsString,
      reply: parseAsString
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQueryStates(t0);
}